export function heroVideo() {
    const _document = this._document;
    const heroSection = _document.querySelector(".hero-section");
    const video = heroSection.querySelector("video");
    const playBtn = heroSection.querySelector(".play-btn");

    if(video) {
        playBtn.addEventListener("click", () => {
            if(playBtn.classList.contains("pause")) {
                playBtn.classList.remove("pause");
                video.pause();
            } else {
                playBtn.classList.add("pause");
                video.play();
            }
    
        });
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/hero-video.js